<template>
  <!--
      作者 luoyiming
      时间：2019-10-26
      描述：设置-上传设置
  -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="200px">
      <!--文件上传设置-->
      <div class="common-form">短信设置</div>
      <el-form-item label="默认上传方式">
        <div>
          <el-radio v-model="form.current" label="AliYun" @change="getRadio">阿里云短信</el-radio>
          <el-radio v-model="form.current" label="Hljw" @change="getRadio">鸿联九五短信</el-radio>
        </div>
      </el-form-item>
      <!--阿里云OSS-->
      <div v-if="form.current == 'AliYun'">
        <el-form-item label="AccessKey"><el-input v-model="form.aliYun.accessKeyId" class="max-w460"></el-input></el-form-item>
        <el-form-item label="AccessKeySecret"><el-input v-model="form.aliYun.accessKeySecret" class="max-w460"></el-input></el-form-item>
        <el-form-item label="短信签名"><el-input v-model="form.aliYun.sign" class="max-w460"></el-input></el-form-item>
        <el-form-item label="短信模板"><el-input v-model="form.aliYun.templateCode" class="max-w460"></el-input></el-form-item>
      </div>
      <!--鸿联九五短信-->
      <div v-if="form.current == 'Hljw'">
        <el-form-item label="接口地址"><el-input v-model="form.hljw.severUrl" class="max-w460"></el-input></el-form-item>
        <el-form-item label="企业账号"><el-input v-model="form.hljw.account" class="max-w460"></el-input></el-form-item>
        <el-form-item label="账户名称"><el-input v-model="form.hljw.accountName" class="max-w460"></el-input></el-form-item>
        <el-form-item label="密码"><el-input v-model="form.hljw.password" class="max-w460"></el-input></el-form-item>
        <el-form-item label="验证码短信模块"><el-input v-model="form.hljw.codeTemplate" class="max-w460"></el-input></el-form-item>
      </div>
      <!--提交-->
      <div class="common-button-wrapper"><el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button></div>
    </el-form>
  </div>
</template>

<script>
import SettingApi from '@/api/setting.js';

export default {
  data() {
    return {
      /*切换菜单*/
      // activeIndex: '1',
      /*form表单数据*/
      form: {
        current: 'AliYun',
        maxImage: '',
        maxVideo: '',
        aliYun: {

        },
        hljw: {
          severUrl:'',
          account:'',
          accountName:'',
          password:'',
          codeTemplate:''
        },
      },
      loading: false
    };
  },
  created() {
    this.getData();
  },

  methods: {
    getData() {
      let self = this;
      SettingApi.smsDetail({}, true)
        .then(res => {
          self.form = res.data;
        })
        .catch(error => {});
    },
    //提交表单
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = this.form;
      SettingApi.editSms(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，上传设置成功',
            type: 'success'
          });
        })
        .catch(error => {
          self.loading = false;
        });
    },
    //监听单选按钮
    getRadio(val) {
      console.log(val)
    }
  }
};
</script>

<style>
.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/sms/index.vue